import { render } from "./PersonaliaPage.vue?vue&type=template&id=a9d15644&scoped=true"
import script from "./PersonaliaPage.vue?vue&type=script&lang=js"
export * from "./PersonaliaPage.vue?vue&type=script&lang=js"

import "./PersonaliaPage.vue?vue&type=style&index=0&id=a9d15644&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9d15644"]])

export default __exports__